export default __webpack_public_path__ + "static/media/selectArrowStyle2.b129d647.svg";